// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
//key
export const environment = {
  production: false,
  //apiUrl: "http://localhost:3500/api",
  apiUrl: "https://api.dev.gotimemotivation.com",
  //apiUrl : 'https://admin.stage.mindsetapp.com/api',
  recaptcha: {
    siteKey: "6LcejUcpAAAAAMnBFvzyU5drmg-DirystQF0xsOk",
  },
};
